export const __DISCOVER_BRAND_NAME__ = 'Discover';
export const __PUSH__ = 'push';
export const __POP__ = 'pop';
export const __DROPDOWN__ = 'DROPDOWN';
export const __DROPDOWNLIST__ = 'DROPDOWNLIST';
export const __CHECKBOX__ = 'CHECKBOX';
export const __COMMENTS__ = 'COMMENTS';
export const __WIZARD_ACCORD__ = 'WIZARD_ACCORDIAN';
export const __CURRENCY__ = 'CURRENCY';
export const __MSGBOX__ = 'MSGBOX';
export const __NESTED_FIELD_SELECTOR__ = 'NestedFieldSelector';
export const __DISPLAY_PANEL__ = 'DisplayPanel';
export const __REVIEW_SCREEN__ = 'ReviewScreen';
export const __DAYS_LEFT_CALENDAR__ = 'DaysLeftCalendar';
export const __MERCHANT_MESSAGE__ = 'MerchantMessage';
export const __AUTO_COMPLETE_DROPDOWN_COMBO__ = 'AUTOCOMPLETEDROPDOWNCOMBO';
export const __VISA_QUESTIONNAIRE__ = 'QUESTIONNAIRE';
export const __UPLOAD_DOCUMENT__ = 'UPLOAD_DOCUMENT';
export const __DATE__ = 'DATE';
export const __TEXT__ = 'TEXT';
export const __USD__ = "USD";
export const __OPTIONAL__ = 'OPTIONAL';
export const __RADIO_BUTTON__ = 'RADIO_BUTTON';
export const __DEFAULT_CURRENCY_LIST__ = [{ text: 'USD', value: 'USD' }, { text: 'GBP', value: 'GBP' }];
export const __MASTERCARD_STAGE_CONFIG_ID__ = [164,165];
export const __MASTERCARD_2700_REASON_CODE__ = 2700;
export const UNDERSCORE_DATE = "_date";
export const PCF_ACTION_CODE = 'PCF';
export const OTHER_PCF_VIOLATION_CODE = "C050";
